import { render, staticRenderFns } from "./PacientesDetalleConsentimientos.vue?vue&type=template&id=7391b9c1&scoped=true"
import script from "./PacientesDetalleConsentimientos.vue?vue&type=script&lang=js"
export * from "./PacientesDetalleConsentimientos.vue?vue&type=script&lang=js"
import style0 from "./PacientesDetalleConsentimientos.vue?vue&type=style&index=0&id=7391b9c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7391b9c1",
  null
  
)

export default component.exports